import { apiClient, REVIEWS } from '../../../../shared/api';
import { DEFAULT_PER_PAGE } from '../../../../shared/constants';

export const fetchReviews = async ({ page = 1, perPage = DEFAULT_PER_PAGE }) => {
  const params = {
    include: 'review_request.client_task.client,review_request.client_task.task',
    page: {
      number: page,
      size: perPage,
    },
  };

  const response = await apiClient.get(REVIEWS, {
    includeWebsite: true,
    params,
  });

  return response.data;
};
